export const THEME = {
    NORMAL: 'normal',
    ACURA: 'acura',
    ACURA_CA: 'acura-CA',
    AUDI: 'audi',
    BMW: 'bmw',
    BUICK: 'buick',
    CADILLAC: 'cadillac',
    CHEVROLET: 'chevrolet',
    CHRYSLER: 'chrysler',
    CJDR: 'cjdr',
    COLOR_SENSITIVE: 'colorSensitive',
    DODGE: 'dodge',
    FORD: 'ford',
    GENESIS: 'genesis',
    GM: 'gm',
    GMC: 'gmc',
    HONDA: 'honda',
    HONDA_CA: 'honda-CA',
    HYUNDAI: 'hyundai',
    INFINITI: 'infiniti',
    JAGUAR: 'jaguar',
    JEEP: 'jeep',
    KIA: 'kia',
    LAND_ROVER: 'landRover',
    LEXUS: 'lexus',
    LEXUS_MONOGRAM: 'lexusMonogram',
    LINCOLN: 'lincoln',
    MAZDA: 'mazda',
    MERCEDES_BENZ: 'mercedesBenz',
    MINI: 'mini',
    NISSAN: 'nissan',
    PORSCHE: 'porsche',
    RAM: 'ram',
    SUBARU: 'subaru',
    TOYOTA: 'toyota',
    TOYOTA_SPM: 'toyotaSPM',
    VOLKSWAGEN: 'volkswagen',
} as const;

export type ThemeName = typeof THEME[keyof typeof THEME];

export function isValidTheme(value: string): value is ThemeName {
    return Object.values(THEME).includes(value as ThemeName);
}

// Themes converted to the CSS light-dark() color-sensitive approach (keep the OEM
// theme active and only swap colors). Every other theme still uses the legacy
// full theme-swap to THEME.COLOR_SENSITIVE. Add a theme here as it is converted.
export const COLOR_SENSITIVE_THEMES: ThemeName[] = [
    THEME.TOYOTA_SPM,
    THEME.CJDR,
];

export function isColorSensitiveTheme(value: string): boolean {
    return COLOR_SENSITIVE_THEMES.includes(value as ThemeName);
}
